<template>
    <ValidationObserver ref="pdd" v-slot="{ handleSubmit }">
      <v-card class="h-100">
        <v-toolbar flat>
          <v-toolbar-title>
            <v-icon left>mdi-account</v-icon>Nominee
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="overflow-80 pt-2">
          <ValidationProvider
            name="Name"
            :rules="{ required: true, max: 10 }"
            v-slot="{ errors }"
          >
            <v-text-field
              v-model="dtls.name"
              outlined
              name="Name"
              label="Name"
              :error-messages="errors"
            >
            </v-text-field>
          </ValidationProvider>
          <ValidationProvider
            name="Relation"
            v-slot="{ errors }"
            rules="required"
          >
            <v-text-field
              outlined
              name="Relation"
              label="Relation"
              :error-messages="errors"
              v-model="dtls.relation"
            >
            </v-text-field>
          </ValidationProvider>
          <ValidationProvider name="Mobile No." v-slot="{ errors }" rules="required">
            <v-text-field
              outlined
              name="Mobile No."
              label="Mobile No."
              :error-messages="errors"
              v-model="dtls.mobileNo"
            >
            </v-text-field>
          </ValidationProvider>
          <ValidationProvider
            name="DOB"
            v-slot="{ errors }"
            rules="required"
          >
            <v-text-field
              outlined
              name="DOB"
              label="DOB"
              :error-messages="errors"
              v-model="dtls.dob"
            >
            </v-text-field>
          </ValidationProvider>
          <ValidationProvider
            name="Percentage"
            v-slot="{ errors }"
            rules="required"
          >
            <v-text-field
              outlined
              name="Percentage"
              label="Percentage"
              :error-messages="errors"
              v-model="dtls.percentage"
            >
            </v-text-field>
          </ValidationProvider>
          <ValidationProvider
            name="Bank Name"
            v-slot="{ errors }"
            rules="required"
          >
            <v-text-field
              outlined
              name="Bank Name"
              label="Bank Name"
              :error-messages="errors"
              v-model="dtls.bankName"
            >
            </v-text-field>
          </ValidationProvider>
          <ValidationProvider
            name="Acc No"
            v-slot="{ errors }"
            rules="required"
          >
            <v-text-field
              outlined
              name="Acc No"
              label="Acc No"
              :error-messages="errors"
              v-model="dtls.accNo"
            >
            </v-text-field>
          </ValidationProvider>
          <ValidationProvider
            name="Acc No"
            v-slot="{ errors }"
            rules="required"
          >
            <v-text-field
              outlined
              name="IFSC Code"
              label="IFSC Code"
              :error-messages="errors"
              v-model="dtls.ifscCode"
            >
            </v-text-field>
          </ValidationProvider>
        </v-card-text>
        <v-card-actions class="d-flex justify-end px-6">
          <v-btn>close</v-btn>
          <v-btn dark color="primary" @click="handleSubmit()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </template>
  <script>
  import { callApi } from "@/api/others";
  import { ValidationObserver, ValidationProvider } from "vee-validate";
  export default {
    components: {
      ValidationObserver,
      ValidationProvider,
    },
    props: {
      mbr:Object
    },
    data: () => ({
      dtls: {},
      MobileNo: "",
      firstName: "",
    }),
    mounted(){
      this.clonembr();
    },
    methods: {
      clonembr(){
        this.dtls = JSON.parse(JSON.stringify(this.mbr));
      },
      closeDialog() {
        this.$emit("closeDialog");
      },
      save(){
        let url = "";
        let data = {
  
        };
        callApi(url,"post",data)
        .then((res)=>{
          this.$refs.common.ManageResponse(res);
        })
        .catch((err)=>{
          this.$refs.common.ManageResponse(err.response);
        })
      }
    },
  };
  </script>
  <style>
  .overflow-80 {
    max-height: 80vh;
    overflow: auto;
  }
  </style>
  